import {Component, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NzAlertModule} from "ng-zorro-antd/alert";
import {NzButtonModule} from "ng-zorro-antd/button";
import {RouterLink} from "@angular/router";
import {NzInputModule} from 'ng-zorro-antd/input';
import {FormsModule} from '@angular/forms';
import {AimsAuthKey, SessionService} from '../@core/session.service';

@Component({
  selector: 'app-unauth',
  standalone: true,
  imports: [CommonModule, NzAlertModule, NzButtonModule, RouterLink, NzInputModule, FormsModule],
  template: `
    <nz-alert
      nzType="error"
      nzMessage="The session is timed-out/invalid"
      [nzDescription]="descriptionTemplate">
    </nz-alert>
    <ng-template #descriptionTemplate>
      <strong>To protect your privacy, please Exit and close your browser when you are finished.</strong>
    </ng-template>
    <div *ngIf="localSetupAuth">
      <input nz-input [(ngModel)]="authToken"/>
      <button (click)="setupAuth()" nz-button>Set Auth</button>
    </div>
  `,
  styles: []
})
export class UnAuthComponent implements OnInit {

  localSetupAuth = false;
  authToken: string = '';

  constructor(private sess: SessionService) {
  }

  ngOnInit(): void {
    if (window.location.hostname == 'localhost') {
      this.localSetupAuth = true;
    }
  }

  async setupAuth() {
    sessionStorage.setItem(AimsAuthKey, this.authToken);
    await this.sess.initJwt(this.authToken);
  }

}
